<template>
    <div>
        <UserPerformanceReport v-if="shouldMountReportsGenerator"
        @upload-completed="handleReportUpload" @upload-failed="handleUploadFailure"
        :user-id="targetUserId" :campaign-id="campaignId">
        </UserPerformanceReport>

        <PsychometryReport v-if="shouldMountPsychometryReportGenerator"
        @upload-completed="handleReportUpload" @upload-failed="handleUploadFailure"
        :campaign-id="campaignId" :assessment-result-id="targetUserId">
        </PsychometryReport>
    </div>
</template>
<script>
import UserPerformanceReport from "../components/UserPerformanceReport.vue";
import PsychometryReport from "../components/PsychometryReport.vue";


export default {
    name: "ReportsTemplateGenerator",
    components: {
        UserPerformanceReport,
        PsychometryReport,
    },
    data(){
        return{
            campaignId: '',
            targetUserId: '',
            reportType: '',
            shouldMountReportsGenerator: false,
            shouldMountPsychometryReportGenerator: false,
        }
    },
    async created(){
        this.campaignId = this.$route.query.campaignId;
        this.targetUserId = this.$route.query.targetUserId;
        this.reportType = this.$route.query.reportType;

        this.shouldMountReportsGenerator = ['userPerformanceReport', 'gtoReport'].includes(this.reportType);
        this.shouldMountPsychometryReportGenerator = ['psychometryReport'].includes(this.reportType);
    },
    methods: {
        handleReportUpload(){
            document.body.setAttribute('template-upload-completed', 'true');
        },
        handleUploadFailure(){
            document.body.setAttribute('template-upload-completed', 'false');
        },
    }
}
</script>